(function () {
  'use strict';

  if (window.cnFacetsInitialized) return;
  window.cnFacetsInitialized = true;

  const ACTIVE_SHADOW = '[data-active-facets-shadow]';
  const ACTIVE_SCROLLER = '[data-active-facets-scroller]';
  const SORT_SELECT = '[data-sort-select]';
  const MOBILE_FORM = '#FacetFiltersFormMobile';
  const MOBILE_CLEAR_WRAPPER = '[data-cn-mobile-clear-wrapper]';
  const MOBILE_CLEAR_LINK = '[data-cn-mobile-clear-link]';
  const CLOSE_MOBILE = '[data-cn-close-mobile-facets]';

  let initFrame = 0;
  let shadowFrame = 0;
  let mobileClearFrame = 0;
  let resizeObserver = null;
  
  const pendingShadowWrappers = new Set();
  const observedScrollers = new WeakSet();
  const shadowState = new WeakMap();

  function asArray(list) {
    return Array.prototype.slice.call(list || []);
  }

  function getActiveFacetWrappers(scope) {
    let root = scope || document;
    let wrappers = [];

    if (root.matches && root.matches(ACTIVE_SHADOW)) {
      wrappers.push(root);
    }

    if (root.querySelectorAll) {
      wrappers = wrappers.concat(asArray(root.querySelectorAll(ACTIVE_SHADOW)));
    }

    return wrappers;
  }

  function measureActiveFacetShadow(wrapper) {
    if (!wrapper) return null;

    let scroller = wrapper.querySelector(ACTIVE_SCROLLER);
    if (!scroller) return null;

    let tolerance = 4;
    let scrollWidth = scroller.scrollWidth;
    let clientWidth = scroller.clientWidth;
    let scrollLeft = Math.max(0, Math.round(scroller.scrollLeft || 0));
    let maxScroll = Math.max(0, Math.round(scrollWidth - clientWidth));
    let hasOverflow = maxScroll > tolerance;
    let atStart = scrollLeft <= tolerance;
    let atEnd = !hasOverflow || scrollLeft >= maxScroll - tolerance;
    let hasActiveFilters = Boolean(scroller.querySelector('facet-remove'));

    return {
      wrapper: wrapper,
      state: {
        hasActiveFilters: hasActiveFilters,
        hasOverflow: hasOverflow,
        atStart: atStart,
        atEnd: atEnd,
        showLeftShadow: hasActiveFilters && hasOverflow && !atStart,
        showRightShadow: hasActiveFilters && hasOverflow && !atEnd
      }
    };
  }

  function sameShadowState(a, b) {
    return Boolean(
      a &&
      b &&
      a.hasActiveFilters === b.hasActiveFilters &&
      a.hasOverflow === b.hasOverflow &&
      a.atStart === b.atStart &&
      a.atEnd === b.atEnd &&
      a.showLeftShadow === b.showLeftShadow &&
      a.showRightShadow === b.showRightShadow
    );
  }

  function applyActiveFacetShadow(measurement) {
    if (!measurement) return;

    let wrapper = measurement.wrapper;
    let next = measurement.state;
    let previous = shadowState.get(wrapper);

    if (sameShadowState(previous, next)) return;

    shadowState.set(wrapper, next);

    wrapper.classList.toggle('has-active-filters', next.hasActiveFilters);
    wrapper.classList.toggle('has-overflow', next.hasOverflow);
    wrapper.classList.toggle('is-at-start', next.atStart);
    wrapper.classList.toggle('is-at-end', next.atEnd);
    wrapper.classList.toggle('show-left-shadow', next.showLeftShadow);
    wrapper.classList.toggle('show-right-shadow', next.showRightShadow);
  }

  function flushShadowUpdates() {
    shadowFrame = 0;

    let wrappers = Array.from(pendingShadowWrappers);
    pendingShadowWrappers.clear();

    /*
      Zuerst ausschließlich Layout lesen, danach Klassen schreiben.
      So entsteht kein Read/Write-Wechsel pro Wrapper.
    */
    let measurements = wrappers
      .map(measureActiveFacetShadow)
      .filter(Boolean);

    measurements.forEach(applyActiveFacetShadow);
  }

  function scheduleShadowWrapper(wrapper) {
    if (!wrapper) return;

    pendingShadowWrappers.add(wrapper);

    if (shadowFrame) return;
    shadowFrame = requestAnimationFrame(flushShadowUpdates);
  }

  function scheduleAllShadowWrappers(scope) {
    getActiveFacetWrappers(scope || document).forEach(function (wrapper) {
      pendingShadowWrappers.add(wrapper);
    });

    if (shadowFrame) return;
    shadowFrame = requestAnimationFrame(flushShadowUpdates);
  }

  function ensureResizeObserver() {
    if (resizeObserver || !('ResizeObserver' in window)) return;

    resizeObserver = new ResizeObserver(function (entries) {
      entries.forEach(function (entry) {
        scheduleShadowWrapper(entry.target.closest(ACTIVE_SHADOW));
      });
    });
  }

  function bindActiveFacetShadows(scope) {
    let root = scope || document;
    let scrollers = [];

    if (root.matches && root.matches(ACTIVE_SCROLLER)) {
      scrollers.push(root);
    }

    if (root.querySelectorAll) {
      scrollers = scrollers.concat(asArray(root.querySelectorAll(ACTIVE_SCROLLER)));
    }

    ensureResizeObserver();

    scrollers.forEach(function (scroller) {
      if (scroller.dataset.cnFacetShadowBound !== 'true') {
        scroller.addEventListener(
          'scroll',
          function () {
            scheduleShadowWrapper(scroller.closest(ACTIVE_SHADOW));
          },
          { passive: true }
        );

        scroller.dataset.cnFacetShadowBound = 'true';
      }

      if (resizeObserver && !observedScrollers.has(scroller)) {
        resizeObserver.observe(scroller);
        observedScrollers.add(scroller);
      }

      scheduleShadowWrapper(scroller.closest(ACTIVE_SHADOW));
    });
  }

  function updateSortSelect(wrapper) {
    if (!wrapper) return;

    let select = wrapper.querySelector('select');
    let text = wrapper.querySelector('[data-sort-select-text]');
    let selectedOption = select && select.options[select.selectedIndex];

    if (!text || !selectedOption) return;

    let nextText = selectedOption.textContent.trim();

    if (text.textContent !== nextText) {
      text.textContent = nextText;
    }
  }

  function updateSortSelects(scope) {
    let root = scope || document;

    asArray(root.querySelectorAll ? root.querySelectorAll(SORT_SELECT) : [])
      .forEach(updateSortSelect);
  }

  function syncSortSelects(changedSelect) {
    if (!changedSelect || changedSelect.name !== 'sort_by') return;

    asArray(document.querySelectorAll('select[name="sort_by"]'))
      .forEach(function (select) {
        if (select === changedSelect) return;

        if (select.value !== changedSelect.value) {
          select.value = changedSelect.value;
        }

        updateSortSelect(select.closest(SORT_SELECT));
      });
  }

  function hasActiveFilterInUrl() {
    let params = new URLSearchParams(window.location.search);

    for (let key of params.keys()) {
      if (key.indexOf('filter.') === 0) return true;
    }

    return false;
  }

  function hasCheckedMobileFilters() {
    let form = document.querySelector(MOBILE_FORM);
    if (!form) return false;

    if (form.querySelector('input[name^="filter."]:checked')) return true;

    return asArray(form.querySelectorAll('input[name^="filter."]'))
      .some(function (input) {
        return (
          input.type !== 'checkbox' &&
          input.value &&
          input.value.trim() !== ''
        );
      });
  }

  function getCleanCollectionUrl() {
    let url = new URL(window.location.href);

    asArray(url.searchParams.keys()).forEach(function (key) {
      if (key.indexOf('filter.') === 0) {
        url.searchParams.delete(key);
      }
    });

    return (
      url.pathname +
      (url.searchParams.toString() ? '?' + url.searchParams.toString() : '')
    );
  }

  function syncMobileClearButton() {
    let wrappers = asArray(document.querySelectorAll(MOBILE_CLEAR_WRAPPER));
    if (!wrappers.length) return;

    let activeFilterPill = document.querySelector(
      '.active-facets-mobile facet-remove:not(.active-facets__button-wrapper) .active-facets__button'
    );

    let activeClearLink = document.querySelector(
      '.active-facets-mobile .active-facets__button-remove'
    );

    let hasActiveFilters =
      Boolean(activeFilterPill) ||
      hasActiveFilterInUrl() ||
      hasCheckedMobileFilters();

    let cleanUrl = activeClearLink ? activeClearLink.href : getCleanCollectionUrl();

    wrappers.forEach(function (wrapper) {
      let link = wrapper.querySelector(MOBILE_CLEAR_LINK);
      if (!link) return;

      if (link.href !== cleanUrl) {
        link.href = cleanUrl;
      }

      wrapper.classList.toggle(
        'cn-mobile-clear-hidden',
        !hasActiveFilters
      );
    });
  }

  function scheduleMobileClearButton() {
    if (mobileClearFrame) return;

    mobileClearFrame = requestAnimationFrame(function () {
      mobileClearFrame = 0;
      syncMobileClearButton();
    });
  }

  function closeMobileFacets(button) {
    let wrapper = button.closest('.mobile-facets__wrapper');
    let summary = wrapper && wrapper.querySelector('summary');

    if (summary) summary.click();
  }

  function initCnFacets(scope) {
    let root = scope || document;

    bindActiveFacetShadows(root);
    updateSortSelects(root);
    scheduleMobileClearButton();
  }

  function scheduleInit(scope) {
    if (initFrame) return;

    initFrame = requestAnimationFrame(function () {
      initFrame = 0;
      initCnFacets(scope || document);
    });
  }

  function handleFormMutation(event) {
    const target = event.target;
    if (!target || !target.closest) return;

    const select = target.closest(SORT_SELECT + ' select');

    if (select) {
      updateSortSelect(select.closest(SORT_SELECT));
      syncSortSelects(select);
    }

    if (target.closest(MOBILE_FORM)) {
      scheduleMobileClearButton();
    }
  }

  document.addEventListener('change', handleFormMutation);
  document.addEventListener('input', handleFormMutation);

  document.addEventListener('click', function (event) {
    let target = event.target;
    if (!target || !target.closest) return;

    let closeButton = target.closest(CLOSE_MOBILE);

    if (closeButton) {
      closeMobileFacets(closeButton);
      return;
    }

    if (
      target.closest(MOBILE_FORM) ||
      target.closest('.active-facets-mobile')
    ) {
      scheduleMobileClearButton();
    }
  });

  if (!('ResizeObserver' in window)) {
    window.addEventListener(
      'resize',
      function () {
        scheduleAllShadowWrappers(document);
        scheduleMobileClearButton();
      },
      { passive: true }
    );
  }

  document.addEventListener('shopify:section:load', function (event) {
    scheduleInit(event.target);
  });

  document.addEventListener('shopify:section:select', function (event) {
    scheduleInit(event.target);
  });

  if (document.body && 'MutationObserver' in window) {
    const mutationObserver = new MutationObserver(function (mutations) {
      let shouldSync = mutations.some(function (mutation) {
        return asArray(mutation.addedNodes).some(function (node) {
          if (node.nodeType !== 1) return false;

          return Boolean(
            (node.matches &&
              node.matches(
                '#ProductGridContainer, #main-collection-filters, .facets-container, .active-facets-mobile'
              )) ||
            (node.querySelector &&
              node.querySelector(
                '#ProductGridContainer, #main-collection-filters, .facets-container, .active-facets-mobile'
              ))
          );
        });
      });

      if (shouldSync) {
        scheduleInit(document);
      }
    });

    mutationObserver.observe(document.body, {
      childList: true,
      subtree: true
    });
  }

  window.ygoInitActiveFacetShadows = bindActiveFacetShadows;
  window.ygoSyncActiveFacetShadows = scheduleAllShadowWrappers;
  window.ygoUpdateSortSelectLabels = updateSortSelects;

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      function () {
        initCnFacets(document);
      },
      { once: true }
    );
  } else {
    initCnFacets(document);
  }
})();
